import { render, staticRenderFns } from "./arrow-up-new-ux.vue?vue&type=template&id=5eabacc4&"
import script from "./arrow-up-new-ux.vue?vue&type=script&lang=js&"
export * from "./arrow-up-new-ux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5eabacc4')) {
      api.createRecord('5eabacc4', component.options)
    } else {
      api.reload('5eabacc4', component.options)
    }
    module.hot.accept("./arrow-up-new-ux.vue?vue&type=template&id=5eabacc4&", function () {
      api.rerender('5eabacc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/arrow-up-new-ux.vue"
export default component.exports